import React from 'react';
import Button from '../ui/Button';
import { FileDown } from 'lucide-react';

export default function ExportButton({ jobs = [], onExport }) {
  
  function handleExport() {
    if (jobs.length === 0) {
      alert('No jobs to export');
      return;
    }

    // Create CSV content
    const headers = [
      'Contract #',
      'Customer Name',
      'Location',
      'Status',
      'Sold Date',
      'Scheduled Date',
      'Windows',
      'Doors',
      'Duration',
      'Crew',
      'Job Type',
      'Notes'
    ];

    const rows = jobs.map(job => [
      job.contractNumber || '',
      job.customerName || '',
      job.name || '',
      job.status || '',
      job.soldDate ? new Date(job.soldDate).toLocaleDateString() : '',
      job.scheduledDate ? new Date(job.scheduledDate).toLocaleDateString() : '',
      job.windowCount || 0,
      job.doorCount || 0,
      job.durationDays || '',
      job.assignedCrew || '',
      job.jobType || '',
      (job.notes || '').replace(/"/g, '""') // Escape quotes in notes
    ]);

    // Build CSV
    const csvContent = [
      headers.join(','),
      ...rows.map(row => row.map(cell => `"${cell}"`).join(','))
    ].join('\n');

    // Create download
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    
    link.setAttribute('href', url);
    link.setAttribute('download', `jobs-export-${new Date().toISOString().slice(0, 10)}.csv`);
    link.style.visibility = 'hidden';
    
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    if (onExport) onExport();
  }

  return (
    <Button
      variant="secondary"
      size="small"
      onClick={handleExport}
    >
      <FileDown size={14} strokeWidth={2} /> Export CSV
    </Button>
  );
}